import firebase from 'firebase/app';
// import 'firebase/auth';        
import 'firebase/storage';     
import 'firebase/database';    

const config = {
  apiKey: "AIzaSyA645WQJ1vp9fvXpAPO6n5deIsqoHIkBrc",
  authDomain: "flutr-1e033.firebaseapp.com",
  databaseURL: "https://flutr-1e033.firebaseio.com",
  projectId: "flutr-1e033",
  storageBucket: "flutr-1e033.appspot.com",
  messagingSenderId: "483270763011",
  appId: "1:483270763011:web:3c1657221d5390a4526436"
};

firebase.initializeApp(config);

export const db = firebase.database();
export const shipmentsRef = db.ref('shipments');
export const butterflyRef = db.ref('butterfly');
export const batchRef = db.ref('batch');
export const bImagesRef = db.ref('butterflyImages');
export const plantRef = db.ref('plants');
export const userRef = db.ref('users');
export const firebaseStorage = firebase.storage().ref();